import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-749dadac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }

import { computed, ref, type CSSProperties } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Drawer',
  props: {
    visible: { type: Boolean },
    width: { default: 320 },
    contentStyle: {},
    placement: { default: 'right' }
  },
  emits: ["update:visible"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const contentVisible = ref(false)

const contentStyle = computed(() => {
  return {
    width: props.width + 'px',
    ...(props.contentStyle || {})
  }
})

return (_ctx: any,_cache: any) => {
  const _component_IconClose = _resolveComponent("IconClose")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      name: `drawer-slide-${_ctx.placement}`,
      onAfterLeave: _cache[1] || (_cache[1] = ($event: any) => (contentVisible.value = false)),
      onBeforeEnter: _cache[2] || (_cache[2] = ($event: any) => (contentVisible.value = true))
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass(['drawer', _ctx.placement]),
          style: _normalizeStyle({ width: props.width + 'px' })
        }, [
          _createElementVNode("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "title"),
            _createElementVNode("span", {
              class: "close-btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:visible', false)))
            }, [
              _createVNode(_component_IconClose)
            ])
          ]),
          (contentVisible.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "content",
                style: _normalizeStyle(contentStyle.value)
              }, [
                _renderSlot(_ctx.$slots, "default")
              ], 4))
            : _createCommentVNode("", true)
        ], 6), [
          [_vShow, _ctx.visible]
        ])
      ]),
      _: 3
    }, 8, ["name"])
  ]))
}
}

})